// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"767":"afb585c7","1899":"afb585c7","2255":"3b1e880a","4621":"afb585c7","5081":"afb585c7","6092":"afb585c7","9238":"3b1e880a"}[chunkId] + ".chunk.css";
};